import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.addEventListener("load", function () {
  const el = document.querySelector("#ovensmash-26-pre-intro .slider_intro");
  if (!el) return;

  new Swiper(el, {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
